import React from "react";
import { ProgressPie } from "@activecollab/components";
import PropTypes from "prop-types";

//@todo proveriti da li boje rade u svim browserima
export const getProgressColor = (percent, transparent = false) => {
  if (percent >= 50 && percent < 75) {
    return transparent ? "color-mix(in srgb, var(--warning), transparent 75%)" : "var(--warning)";
  }
  if (percent >= 75 && percent < 90) {
    return transparent ? "color-mix(in srgb, var(--color-sucess-green), transparent 50%)" : "var(--color-sucess-green)";
  }
  return transparent ? "color-mix(in srgb, var(--red-alert), transparent 75%)" : "var(--red-alert)";
};
export const UtilizationPie = ({ utilization, radius, className }) => {
  return (
    <ProgressPie
      radius={radius}
      progress={utilization}
      className={className}
      progressColor={getProgressColor(utilization)}
    />
  );
};

UtilizationPie.propTypes = {
  utilization: PropTypes.number,
  radius: PropTypes.number,
  className: PropTypes.string,
};

UtilizationPie.defaultProps = {
  utilization: 0,
  radius: 6,
};
